import { useEffect, useRef } from 'react'

// Ячейка «Заметка» в таблице позиций. Textarea с автоподстройкой высоты:
// перестраивается при изменении значения (и при первом монтировании, когда
// парсер подставил длинную заметку). Enter без Shift переводит фокус на
// следующую строку; Shift+Enter — стандартный перенос.
function autoResize(el: HTMLTextAreaElement) {
  el.style.height = 'auto'
  el.style.height = el.scrollHeight + 'px'
}

interface NoteCellProps {
  value: string
  onChange: (v: string) => void
  onRegister: (el: HTMLTextAreaElement | null) => void
  onEnter: () => void
  onCtrlDelete: () => void
  cellClass: string
}

export function NoteCell({
  value,
  onChange,
  onRegister,
  onEnter,
  onCtrlDelete,
  cellClass,
}: NoteCellProps) {
  const localRef = useRef<HTMLTextAreaElement | null>(null)

  useEffect(() => {
    if (localRef.current) autoResize(localRef.current)
  }, [value])

  return (
    <textarea
      ref={(el) => {
        localRef.current = el
        onRegister(el)
      }}
      value={value}
      rows={1}
      onChange={(e) => {
        onChange(e.target.value)
        autoResize(e.target)
      }}
      onKeyDown={(e) => {
        if (e.key === 'Enter' && !e.shiftKey) {
          e.preventDefault()
          onEnter()
        } else if (e.key === 'Delete' && e.ctrlKey) {
          e.preventDefault()
          onCtrlDelete()
        }
      }}
      placeholder="срочно, замена..."
      style={{ overflow: 'hidden', resize: 'none' }}
      className={`${cellClass} leading-relaxed`}
    />
  )
}
